import { useEffect, useState } from "react";
import mainStore from "store/mainStore";

import CreateSale from "./CreateSale";
import ListSale from "./ListSales";
import ModelSale from "./ModelSale";
import Button from "components/Buttons/StdButton";
import proxy from "api/proxy";
import { useStoreRest } from "apps/RestOrder/storeRest";

const SaleCallCenter = ({ config }) => {
  const [configSale, setConfigSale] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewType, setViewType] = useState("");
  const [listViewType, setListViewType] = useState("list");
  const [title, setTitle] = useState("Crear Orden");
  const { reset, newRecord } = mainStore.getState();
  const ctxViewSale = configSale ? ModelSale.ctxView(configSale) : null;

  function onClickAction(_, name) {
    let name_ = name;
    let title = "Registro de pedidos";
    if (name_ === "cancel") {
      name_ = "";
    } else if (name_ === "list") {
      title = "Ordenes";
      setListViewType("list");
    }
    setViewType(name_);
    setTitle(title);
    reset(true);
    newRecord(ctxViewSale);
  }

  async function onListChangeView(_, action, rec) {
    let newView = listViewType;
    if (["edit", "add"].includes(action)) {
      newView = "form";
    } else if (["editModal", "addModal"].includes(action)) {
      newView = "modalForm";
    } else {
      newView = "list";
    }
    if (!rec) {
      const { reset: resetStore } = mainStore.getState();
      resetStore(true);
    } else {
      const { setRecord } = mainStore.getState();
      const { initShop, setIsFilterByShop } = useStoreRest.getState();
      const shopId = rec?.shop?.id ?? rec?.shop;
      await initShop(shopId);
      await setIsFilterByShop();
      await setRecord(rec.id, ctxViewSale.model, ctxViewSale);
    }
    setListViewType(newView);
  }

  useEffect(() => {
    async function getConfigSale() {
      const [configRes, moduleRes] = await Promise.all([
        proxy.search("sale.configuration", [], ["filter_product_by_analytic"]),
        proxy.search(
          "ir.module",
          [
            ["name", "=", "product_tag"],
            ["state", "=", "activated"],
          ],
          ["state"],
        ),
      ]);
      const isTagsActive =
        moduleRes.data?.length > 0 && moduleRes.data[0].state === "activated";

      useStoreRest.setState({ isTagsActive });

      setConfigSale({
        ...config,
        ...configRes.data?.[0],
        productTagActive: isTagsActive,
      });
      setLoading(false);
    }
    getConfigSale();
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto my-4">
        <div className="flex justify-center items-center h-64">
          <span className="text-gray-400">Cargando...</span>
        </div>
      </div>
    );
  }

  const size_button = "flex-grow basis-[200px] h-14 xl:h-16";
  return (
    <div className="container mx-auto my-4">
      <h3 className="text-center leading-normal font-semibold text-4xl mt-0 mb-3 text-gray-800 ">
        {title}
      </h3>
      {/* <TimeLine /> */}
      <div className="flex flex-wrap justify-evenly  gap-3 xl:gap-5">
        <Button
          style={"  "}
          onClick={onClickAction}
          name={"create"}
          disabled={viewType === "create"}
          color={"green"}
          size={size_button}
          content={"sale.callcenter.create"}
        />
        <Button
          style={"  "}
          onClick={onClickAction}
          name={"list"}
          disabled={viewType === "create"}
          color={"blue"}
          size={size_button}
          content={"sale.callcenter.view"}
        />
        <Button
          style={"  "}
          onClick={onClickAction}
          name={"cancel"}
          disabled={viewType !== "create"}
          color={"rose"}
          size={size_button}
          content={"sale.callcenter.cancel"}
        />
      </div>
      {viewType === "create" ? (
        <CreateSale ctxView={ctxViewSale} />
      ) : viewType === "list" ? (
        <ListSale
          ctxView={ctxViewSale}
          viewType={listViewType}
          onChangeView={onListChangeView}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default SaleCallCenter;
